// @flow
import { MediosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    medio: {},
    listaMedios: [],
    loading: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type MediosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { medio?: {} | null, listaMedios?: [] | null, loading?: boolean, +value ?: boolean };

const Medios = (state: State = INIT_STATE, action: MediosAction): any => {
    // console.log(action);
    switch (action.type) {
        case MediosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case MediosActionTypes.GET_MEDIO: {
                    return {
                        ...state,
                        medio: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case MediosActionTypes.LIST_MEDIOS: {
                    return {
                        ...state,
                        listaMedios: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case MediosActionTypes.ADD_MEDIO: {
                    return {
                        ...state,
                        medio: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case MediosActionTypes.UPDATE_MEDIO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case MediosActionTypes.DELETE_MEDIO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case MediosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case MediosActionTypes.GET_MEDIO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        medio: {},
                        loading: false,
                    };
                }
                case MediosActionTypes.LIST_MEDIOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaMedios: [],
                        loading: false,
                    };
                }
                case MediosActionTypes.ADD_MEDIO: {
                    return {
                        ...state,
                        medio: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case MediosActionTypes.UPDATE_MEDIO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case MediosActionTypes.DELETE_MEDIO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case MediosActionTypes.GET_MEDIO:
            return { ...state, error: false, loading: true };
        case MediosActionTypes.LIST_MEDIOS:
            return { ...state, error: false, loading: true };
        case MediosActionTypes.ADD_MEDIO:
            return { ...state, error: false, loading: true };
        case MediosActionTypes.UPDATE_MEDIO:
            return { ...state, error: false, loading: true };
        case MediosActionTypes.DELETE_MEDIO:
            return { ...state, error: false, loading: true };
        case MediosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                medio: {},
                listaMedios: [],
                formSubmited: false
            };
        case MediosActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Medios;
